import { API_HEADERS, MIDDLEWARE } from "../Utils";


export const fetchQuestionnaireData = async ({middleware, questionnaireId}) => {
    try {
        
        
        const apiUrl = `${middleware || MIDDLEWARE}/edge-folder-management/api/v2/folder/questionnaire/${questionnaireId}`;

        const response = await fetch(apiUrl, {
            method: "GET",
            headers: {
                ...API_HEADERS,
            },
            credentials: "include",
        });

       

        const questionnaireData = await response.json();
        return questionnaireData;
    } catch (error) {
        console.error("fetchQuestionnaireError", error);
        return null;
    }
};
